import { render, staticRenderFns } from "./ImgUpload.vue?vue&type=template&id=5b61c8d7&"
import script from "./ImgUpload.vue?vue&type=script&lang=js&"
export * from "./ImgUpload.vue?vue&type=script&lang=js&"
import style0 from "./ImgUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports